<template>
  <div class>
    <van-tabs v-model="activePrintStatus" @change="switchTab" swipeable>
      <van-tab title="未打印"> </van-tab>
      <van-tab title="已打印"></van-tab>
      <van-tab title="全部"></van-tab>
    </van-tabs>
      <section
        v-for="(item, index) in subBody"
        :key="index"
        class="summary"
        @click="checkProve(item)"
      >
        <div>
          <p>
            <span class="p-name">{{ item.name }} <label>({{ item.EMPLID }})</label></span>
            <span
              class="p-title"
              :class="item.printStatus == 'N' ? 'p-status-n' : ''" >{{ item.printStatus | statusFmt }}</span>
          </p>
          <p>
            <label>{{item.company}}&nbsp;{{ item.deptName }}&nbsp;&nbsp;&nbsp;&nbsp;{{ item.positionDesc }}</label>
          </p>
          <p>
            <span><label>申请时间：</label>{{ item.applyData | datefmt }}</span>
            <span class="p-title"><label>申请类型：</label>{{ item.applyType | typefmt }}</span>
          </p>
        </div>
      </section>
  </div>
</template>
 
<script>
import dateformat from "@/utils/dateformat";

export default {
  props: ["subBody", "subBodyAll", "subBodyPrinted", "subBodyNotPrint"],
  data() {
    name: "listcert";
    return {
      activePrintStatus: 0,
    };
  },
  methods: {
    switchTab() {
      //切换数据
      switch(this.activePrintStatus){
        case 0: this.subBody = this.subBodyNotPrint; break;
        case 1: this.subBody = this.subBodyPrinted; break;
        case 2: this.subBody = this.subBodyAll; break;
      }
    },
    checkProve(item) {
      let applyType = item.applyType.toLowerCase();
      let routePage = "";
      switch (applyType) {
        case "income":
          routePage = "certincomedetail";
          break;
        case "onjob":
          routePage = "certonjobdetail";
          break;
        default:
          return;
      }
      this.$router.push({ path: routePage, query: item });
    },
  },
  filters: {
    datefmt(val) {
      if (!val) return "";
      return dateformat("yyyy/MM/dd", new Date(val));
    },
    dayfmt(val) {
      //用于计算异常的时长（按8小时计算）
      let dayMinutes = 8 * 60.0;

      if (!val) return "";
      return new Number(parseInt(val) / dayMinutes).toFixed(1);
    },
    typefmt(val) {
      if (!val) return "";
      if (val.toLowerCase() === "onjob") return "在职证明";
      if (val.toLowerCase() === "income") return "收入证明";
    },
    statusFmt(val) {
      if (!val) return "";
      if (val.toLowerCase() === "n") return "未打印";
      return "已打印";
    },
  },
  created() {
    this.activePrintStatus = 0;
    this.subBody = this.subBodyNotPrint;
  },
};
</script>
 
<style lang = "less" scoped>
.summary {
  margin: 10px 16px 0;
  padding: 10px 10px;
  background: white;
  border-radius: 10px;
  div {
    font-size: 14px;
    line-height: 30px;
    p {
      span {
        color: black;
      }
      span.p-name {
        font-size: 1.1rem;
        label {
          font-size: 0.9rem;
        }
      }
      span.p-title {
        float: right;
      }
      span.p-status-n {
        color: red;
      }
      label {
        color: #aaa !important;
      }
    }
  }
}
</style>